module.exports = __webpack_public_path__ + "static/media/group-people-community-Inactive.5c85e7bb.svg";